import { Stream } from '@24i/nxg-sdk-photon';

export const verifyStreamUrl = async (stream: Stream): Promise<boolean> => {
    try {
        if (!['hls', 'dash', 'smoothstreaming'].includes(stream.type)) return true; // only check manifests
        if (!stream.url) return true; // we cannot verify SSAI streams
        const response = await fetch(stream.url, { method: 'HEAD' })
            .then((headResponse) => {
                if (!headResponse.ok) {
                    throw new Error('Invalid stream URL or HEAD not supported');
                }
                return headResponse;
            })
            .catch(async () => {
                // If fails with HEAD request, try with GET
                return fetch(stream.url as string, { method: 'GET' });
            });
        return response.ok;
    } catch {
        return false;
    }
};
